// ============================================================================
// EMPTY STATE — rendu DOM de l'état vide honnête (§24.9sexies-ter e / §23.0), extrait VERBATIM du
// composant pilote de la Console. L'icône se passe par NOM (registre partagé `ui-tokens/icons`) —
// plus aucun registre local d'icônes de vide. Anatomie en données (`ui-tokens/empty-state`).
// Pendant RN : `ui-native/empty-state` (géométrie tablette propre, même SENS).
// ============================================================================
import type { CSSProperties, ReactNode } from 'react';
import { EMPTY_STATE, type IconName } from '@orgazone/ui-tokens';
import { Icon } from './icons';

export interface EmptyStateProps {
  /** Nom d'icône du registre partagé (ex. "calendar", "store", "pulse"). */
  icon: IconName;
  title: string;
  /** Pourquoi c'est vide et ce qui le remplira — jamais du meublage. */
  note: ReactNode;
  /** Bouton/lien optionnel sous la note (l'action qui remplira ce vide). */
  action?: ReactNode;
  /** Variante resserrée pour les cartes latérales / sections de dashboard. */
  compact?: boolean;
  style?: CSSProperties;
}

export function EmptyState({ icon, title, note, action, compact, style }: EmptyStateProps) {
  const t = EMPTY_STATE;
  const c = t.compact;
  return (
    <div style={{ padding: compact ? c.padding : t.padding, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center', ...style }}>
      <div style={{
        width: compact ? c.tile : t.tile, height: compact ? c.tile : t.tile,
        borderRadius: compact ? c.tileRadius : t.tileRadius, display: 'grid', placeItems: 'center',
        background: 'var(--ink-100)', color: 'var(--ink-400)', marginBottom: compact ? c.tileGap : t.tileGap,
      }}>
        <Icon name={icon} size={t.iconSize} stroke={t.iconStroke} />
      </div>
      <div style={{ fontSize: compact ? c.titleSize : t.titleSize, fontWeight: t.titleWeight }}>{title}</div>
      <div style={{ fontSize: compact ? c.noteSize : t.noteSize, color: 'var(--ink-500)', marginTop: 6, lineHeight: 1.55, maxWidth: t.noteMaxWidth }}>{note}</div>
      {action && <div style={{ marginTop: t.actionGap }}>{action}</div>}
    </div>
  );
}
